import { useMemo } from "react";

import { type ReactionUser } from "./ReactionUser";

/**
 * Splits `reactions` into:
 *
 *   - `currentUserReacted`, indicating whether the current user reacted
 *   - `visibleReactions`, the list of reactions that are going to be visible which are NOT the
 *     current user's reaction
 *   - `overflowReactions`, the list of reactions that are going to be hidden behind an avatar with
 *     the text `+1`, `+2`, etc.
 */
export const useReactionsSummary = (reactions: ReactionUser[], currentUser?: ReactionUser) => {
	return useMemo(() => {
		let overflowReactions = reactions.filter((reaction) => reaction.id !== currentUser?.id);
		const currentUserReacted = overflowReactions.length !== reactions.length;

		let visibleReactions: ReactionUser[] = [];
		if (!currentUserReacted && overflowReactions[0]) {
			visibleReactions = [overflowReactions[0] as ReactionUser];
			overflowReactions = overflowReactions.slice(1);
		}

		const avatarGroupSize = 1;

		return { currentUserReacted, visibleReactions, overflowReactions, avatarGroupSize };
	}, [reactions, currentUser]);
};
